import React, { useState, useEffect } from 'react';
import useAxios from 'hooks/useAxios';
import {
    Card,
    CardBody,
    CardTitle,
    Col,
    Row,
    CardHeader,
    Button,
    Nav,
    NavItem,
    NavLink,
} from 'reactstrap';
import ErrorBoundary from 'components/ErrorBoundary';
import PlanSpendPMPMDrawer from '../GridData/PlanSpendDrawer';
import Drawer from 'components/Drawer';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    ArcElement,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import CustomeDate from 'pages/ClientDashBoard/Components/Widgets/CustomeDate';
ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    ArcElement
);

ChartJS.register(ArcElement, Tooltip, Legend);

const plugin = {
    beforeInit(chart) {
        // Get reference to the original fit function
        const originalFit = chart.legend.fit;

        // Override the fit function
        chart.legend.fit = function fit() {
            // Call original function and bind scope in order to use `this` correctly inside it
            originalFit.bind(chart.legend)();
            // Change the height as suggested in another answers
            this.height = this.height + 25;
        };
    },
};

const PlanSpendPMPM = ({ dateRange, planId, groupId, startDate, endDate, rebatechecked,planCode,groupCode }) => {
    const API = useAxios();
    const [active, setActive] = useState('3');
    const [graphData, setGraphData] = useState(null);
    const [options, setOptions] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [disabledViewButtom, setDisabledViewButtom] = useState(true);
    useEffect(() => {
        setActive(dateRange);
        getPlanSpendPMPM();
    }
        , [dateRange, planId, groupId, startDate, endDate,rebatechecked,planCode,groupCode]);


    const getPlanSpendPMPM = async () => {
        const { data } = await API.get(
            `/PBMTenant/${planId}/PBMClientDashboard/getPlanSpendPMPM/${groupId}/${dateRange}/${startDate}/${endDate}/${rebatechecked}/${planCode}/${groupCode}`);
        if (data) {
            let grpOptions = {
                responsive: true,
                scales: {
                    x: {
                        ticks: {
                            color: '#000',
                            size: 15,
                        },
                    },
                    y: {
                        border: {
                            display: false,
                        },
                        ticks: {
                            // include a dollar sign in the ticks
                            callback: function (value, index, values) {
                                if (value >= 1000) {
                                    return (
                                        '$' + (value / 1000) + 'k'
                                    );
                                }
                                else {
                                    return (
                                        '$' + value
                                    );
                                }

                            }
                        },
                    },
                },
                plugins: {
                    legend: {
                        position: 'bottom',
                        labels: {
                            padding: 15,
                            usePointStyle: true,
                            pointStyle: 'rect',
                            color: '#707070',
                            font: {
                                weight: 'bold',
                            },
                        },
                        align: 'start',
                    },
                    tooltip: {
                        enabled: true,
                        position: 'nearest',
                        callbacks: {
                            label: function (d, t) {
                                var xLabel = d.dataset.label;
                                var yLabel = '$' + d.formattedValue;
                                return xLabel + ': ' + yLabel;
                            },
                        },
                    },
                    datalabels: {
                        display: false,
                        align: function (context) {
                            return context.dataset.data[context.dataIndex] < 150000
                                ? 'end'
                                : 'start';
                        },
                        color: function (context) {
                            return context.dataset.data[context.dataIndex] < 150000
                                ? 'black'
                                : 'black';
                        },
                        anchor: 'end',
                        padding: {
                            right: 2,
                        },
                        labels: {
                            padding: { top: 10 },
                            value: {
                                color: '#2B3346',
                            },
                        },
                        formatter: function (value) {
                            return (
                                '$' + value.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
                            );
                        },
                    },
                },

            };

            setOptions(grpOptions);
            const data1 = {
                labels: ['Q1', 'Q2', 'Q3', 'Q4'],
                PMPM: [  Number(data.q1).toFixed(2),
                        Number(data.q2).toFixed(2),
                        Number(data.q3).toFixed(2),
                        Number(data.q4).toFixed(2),]
            };
            let grpData = {
                labels: data1.labels,
                datasets: [
                    {
                        label: 'PMPM',
                        data: data1?.PMPM,
                        borderColor: "#702C62",
                        backgroundColor: "#702C62",
                        pointRadius: 2.5
                    }
                ],
            };

            setGraphData(grpData);
            if (data?.q1 != null, data?.q2 != null, data?.q3 != null, data?.q4 != null) {
                setDisabledViewButtom(false);
            }
            else {
                setDisabledViewButtom(true);
            }

        }

    }

    const handleActive = (title) => {
        setActive(title);
    };
    const getDate = () => {
        setActive('custom')
    }
    const handleProceed = () => {
        setIsOpen(!isOpen);
    }
    const onHandleIsOpen = (hasRefresh) => {
        if (isBoolean(hasRefresh) && hasRefresh) {
            onClose(true);
        }
        setIsOpen(!isOpen)
    }
    return (
        <ErrorBoundary>
            <Card className='p-3 h-100'>
                <CardHeader className='border-0 bg-white px-0 pt-0'>
                    <Row className='align-items-center'>
                        <Col>
                            <CardTitle className='f-20 font-weight-500'>
                                Plan Spend PMPM
                                <span className='qu_icon' style={{ "paddingLeft": "10px" }} data-title={"The total Plan Paid amount for the net processed, non-reversed claims per month."}>
                                    {/* <img src={QuestionIcon} style={{"width":"20px"}} /> */}
                                </span>
                            </CardTitle>
                        </Col>
                        <Col xs='auto' hidden={true}>
                            <Nav className='widget-tabs'>
                                <NavItem>
                                    <NavLink
                                        className={
                                            active === '3'
                                                ? 'active-tab cursor-pointer f-12'
                                                : 'cursor-pointer f-12'
                                        }
                                        onClick={() => handleActive('3')}
                                    >
                                        3 Mon
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={
                                            active === '6'
                                                ? 'active-tab cursor-pointer f-12'
                                                : 'f-12 cursor-pointer'
                                        }
                                        onClick={() => handleActive('6')}
                                    >
                                        6 Mon
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={
                                            active === '12'
                                                ? 'active-tab cursor-pointer f-12'
                                                : 'cursor-pointer f-12'
                                        }
                                        onClick={() => handleActive('12')}
                                    >
                                        1 Yr
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink className={
                                        active === 'custom'
                                            ? 'active-tab cursor-pointer f-12'
                                            : 'cursor-pointer f-12'
                                    }>
                                        <CustomeDate getDate={getDate} active={active} />
                                    </NavLink>
                                </NavItem>
                            </Nav>
                        </Col>
                    </Row>
                </CardHeader>
                <CardBody className='dashboard-chart-body'>
                    {graphData && (<Line options={options} data={graphData} plugins={[plugin]} />)}
                    <div className="view-report">
                        <Button
                            color='primary'
                            className='ms-2'
                            onClick={handleProceed}
                           style={{ float: "right", position: "absolute", bottom: "3px", right: "30px"}}
                            disabled={disabledViewButtom}
                          
                        >
                            View Report
                        </Button>
                    </div>
                </CardBody>
            </Card>
             <Drawer
            direction='end'
            title='Plan Spend PMPM'
            isOpen={isOpen}
            toggle={handleProceed}
            size="lg"
        >
            <PlanSpendPMPMDrawer dateRange={dateRange} planId={planId} groupId={groupId} startDate={startDate} endDate={endDate} planCode={planCode} groupCode={groupCode} onHandleIsOpen={onHandleIsOpen}   rebatechecked={rebatechecked} />
        </Drawer> 
        </ErrorBoundary>
    );
};

export default PlanSpendPMPM;
